import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSubTestPing,
  getCustomerTargets4,
  getCustomerTargets6,
  updateCustomerTargets4,
  updateCustomerTargets6,
  updateSubTestPing,
  getSubTestTr,
  updateSubTestTr,
  getCustomerPoELoad,
  updateCustomerPoELoad,
  getNetScan,
  updateNetScan,
  getUpTime,
  updateSubTestUptime,
  getMaxThroughPut,
  updateMaxThroughPut,
  getWireMap,
  getCableList,
  updateCableList,
  DeleteCable,
  getSubtestSettings,
  updateSubTestSettings,
  updateWireMap,
  getFiberLengthLoss,
  updateFiberLengthLoss,
} from "../../redux/actions";
import Ping from "../../components/subtestsetting/ping";
import Tr from "../../components/subtestsetting/tr";
import PoELoad from "../../components/subtestsetting/poeLoad";
import NoData from "../../components/nodata";
import Targets from "../../components/targets";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import NetScan from "../../components/subtestsetting/netscan";
import UpTime from "../../components/subtestsetting/uptime";
import MaxThroughPut from "../../components/subtestsetting/maxthroughput";
import WireMap from "../../components/subtestsetting/wiremap";

import WireMapCustCable from "../../components/subtestsetting/wiremapcustcable";

import CustomData from "../../components/subtestsetting/customdata";
import CableData from "../../components/subtestsetting/cabledata";
import WebData from "../../components/subtestsetting/webdata";
import VoIPData from "../../components/subtestsetting/voipdata";
import VideoData from "../../components/subtestsetting/videodata";
import CCTVData from "../../components/subtestsetting/cctvdata";

import FiberLengthLoss from "../../components/subtestsetting/fiberlengthloss";
import FiberLength from "../../components/subtestsetting/fiberlength";

class SubTestSettingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lengthMeasurementUnit: null,
      customerTargets4: [],
      customerTargets6: [],
      selectedTestResult: null,
      selectedTrResult: null,
      subTestTargetResult: null,
      pingErrors: {},
      ipvErrors: {},
      subTestIpvUpdated: false,
      subTestPingUpdated: false,
      netScan: {},
      upTime: {},
      maxThroughPut: {},
      wireMap: {},
      fiberLengthLoss: {},
      fiberLength: {},

      cableList: {},

      subtestSettings: {}
    };
  }
  componentWillReceiveProps(nextProps) {
    const {
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      selectedTrResult,
      subTestPingUpdated,
      subTestIpvUpdated,
      netScan,
      upTime,
      maxThroughPut,
      wireMap,
      fiberLengthLoss,
      fiberLength,

      cableList,

      subtestSettings
    } = nextProps;

    this.setState({
      subTestPingUpdated,
      subTestIpvUpdated,
      netScan: netScan,
      upTime,
      maxThroughPut,
      wireMap,
      fiberLengthLoss,
      fiberLength,

      cableList,

      subtestSettings
    });
    if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
      this.setState({ customerTargets4 });
    }
    if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
      this.setState({ customerTargets6 });
    }
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
  }

  render() {
    const { translate, profile } = this.props;
    const { lengthMeasurementUnit } = this.state;
    if (profile && (lengthMeasurementUnit == null)) {
      this.setState({
        lengthMeasurementUnit: profile.units
      });
    }
    const {
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      selectedTrResult,
      netScan,
      upTime,
      wireMap,

      cableList,

      ipvErrors,
      maxThroughPut,
      fiberLengthLoss,
      fiberLength,
      subtestSettings
    } = this.state;
    let navitek = false;
    switch (this.props.match.params.cid) {
      case "ipv4":
        return (
          <Targets
            translate={translate}
            selectedTest={this.props.match.params.cid}
            customerTargets={customerTargets4}
            getCustTargets4={this.props.getCustTargets4}
            updateCustTargets4={this.props.updateCustTargets4}
          />
        );
        break;
      case "ipv6":
        return (
          <Targets
            translate={translate}
            selectedTest={this.props.match.params.cid}
            customerTargets={customerTargets6}
            getCustTargets6={this.props.getCustTargets6}
            updateCustTargets6={this.props.updateCustTargets6}
          />
        );
        break;
      case "ping4":
        return (
          <Ping
            selectedTest={this.props.match.params.cid}
            translate={this.props.translate}
            selectedTestResult={selectedTestResult}
            subTestTargetResult={customerTargets4}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets4}
            updatePingDetails={this.props.updatePingDetails}
          />
        );
        break;
      case "ping6":
        return (
          <Ping
            selectedTest={this.props.match.params.cid}
            translate={this.props.translate}
            selectedTestResult={selectedTestResult}
            subTestTargetResult={customerTargets6}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets6}
            updatePingDetails={this.props.updatePingDetails}
          />
        );
        break;
      case "poeload":
        return (
          <PoELoad
            translate={this.props.translate}
            customerPoELoad={this.props.customerPoELoad}
            getCustPoELoad={this.props.getCustPoELoad}
            updateCustPoELoad={this.props.updateCustPoELoad}
          />
        );
      case "traceroute4":
        return (
          <Tr
            selectedTest={this.props.match.params.cid}
            translate={this.props.translate}
            selectedTrResult={selectedTrResult}
            subTestTargetResult={customerTargets4}
            getTrDetails={this.props.getTrDetails}
            getPingTargetList={this.props.getCustTargets4}
            updateTrDetails={this.props.updateTrDetails}
          />
        );
        break;
      case "traceroute6":
        return (
          <Tr
            selectedTest={this.props.match.params.cid}
            translate={this.props.translate}
            selectedTrResult={selectedTrResult}
            subTestTargetResult={customerTargets6}
            getTrDetails={this.props.getTrDetails}
            updateTrDetails={this.props.updateTrDetails}
            getPingTargetList={this.props.getCustTargets6}
          />
        );
        break;
      case "netscan":
        return (
          <NetScan
            netScan={netScan}
            translate={this.props.translate}
            getNetScan={this.props.getNetScan}
            updateNetScan={this.props.updateNetScan}
          />
        );
        break;
      case "uptime":
        return (
          <UpTime
            translate={this.props.translate}
            upTime={upTime}
            getUpTime={this.props.getUpTime}
            updateSubTestUptime={this.props.updateSubTestUptime}
          />
        );
        break;
      case "maxthroughput":
        return (
          <MaxThroughPut
            translate={this.props.translate}
            maxThroughPut={this.props.maxThroughPut}
            getMaxThroughPut={this.props.getMaxThroughPut}
            updateMaxThroughPut={this.props.updateMaxThroughPut}
            error={this.props.error}
            selectedTest={this.props.match.params.cid}
          />
        );
        break;
      case "wiremapcustomcables":
        return (
          <WireMapCustCable
            translate={this.props.translate}
            getWireMap={this.props.getWireMap}
            getCableList={this.props.getCableList}
            wireMap={wireMap}
            cableList={cableList}
            updateCableList={this.props.updateCableList}
            DeleteCable={this.props.DeleteCable}
          />
        );
        break;
      case "wiremapnt":
        navitek = true;
      case "wiremap":
        return (
          <WireMap
            translate={this.props.translate}
            wireMap={wireMap}
            getWireMap={this.props.getWireMap}
            getCableList={this.props.getCableList}
            cableList={cableList}
            updateWireMap={this.props.updateWireMap}
            isNavitek={navitek}
          />
        );
        break;
      case "customdata":
        return (
          <CustomData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "cabledata":
        return (
          <CableData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "webdata":
        return (
          <WebData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "voipdata":
        return (
          <VoIPData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "videodata":
        return (
          <VideoData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "cctvdata":
        return (
          <CCTVData
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.props.updateSubTestSettings}
          />
        );
        break;
      case "fiberlengthloss":
        return (
          <FiberLengthLoss
            fiberLengthLoss={this.props.fiberLengthLoss}
            translate={this.props.translate}
            getFiberLengthLoss={this.props.getFiberLengthLoss}
            updateFiberLengthLoss={this.props.updateFiberLengthLoss}
            lengthMeasurementUnit={lengthMeasurementUnit}
          />
        );
        break;
      case "fiberlength":
        return (
          <FiberLength
            fiberLengthLoss={this.props.fiberLengthLoss}
            translate={this.props.translate}
            getFiberLength={this.props.getFiberLength}
            updateFiberLengthLoss={this.props.updateFiberLengthLoss}
            lengthMeasurementUnit={lengthMeasurementUnit}
          />
        );
      default:
        return (
          <NoData
            translate={this.props.translate}
            noDataText="no_job_data_undeveloped"
          />
        );
    }
  }
}

const mapStateToProps = state => ({
  selectedTestResult: state.subtestReducer.selectedTestResult,
  subTestPingUpdated: state.subtestReducer.subTestPingUpdated,
  customerTargets4: state.customerReducer.customerTargets4,
  customerTargets6: state.customerReducer.customerTargets6,
  subTestIpvUpdated: state.customerReducer.subTestIpvUpdated, //add ipv6 if needed in the future
  customerPoELoad: state.customerReducer.customerPoELoad,
  selectedTrResult: state.subtestReducer.selectedTrResult,
  netScan: state.subtestReducer.netScan,
  upTime: state.subtestReducer.upTime,
  maxThroughPut: state.subtestReducer.maxThroughPut,
  wireMap: state.subtestReducer.wireMap,
  fiberLengthLoss: state.subtestReducer.fiberLengthLoss,
  fiberLength: state.subtestReducer.fiberLength,
  error: state.subtestReducer.error,
  profile: state.userReducer.user,

  cableList: state.subtestReducer.cableList,

  subtestSettings: state.subtestReducer.subtestSettings,

  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getPingDetails: cid => {
    dispatch(getSubTestPing(cid));
  },
  getCustTargets4: id => {
    dispatch(getCustomerTargets4(id));
  },
  getCustTargets6: id => {
    dispatch(getCustomerTargets6(id));
  },
  updateCustTargets4: (id, targetList) => {
    dispatch(updateCustomerTargets4(id, targetList));
  },
  updateCustTargets6: (id, targetList) => {
    dispatch(updateCustomerTargets6(id, targetList));
  },
  updatePingDetails: (id, pingDetails) => {
    dispatch(updateSubTestPing(id, pingDetails));
  },
  getCustPoELoad: () => {
    dispatch(getCustomerPoELoad());
  },
  updateCustPoELoad: poeload => {
    dispatch(updateCustomerPoELoad(poeload));
  },
  getTrDetails: cid => {
    dispatch(getSubTestTr(cid));
  },
  updateTrDetails: (id, trDetails) => {
    dispatch(updateSubTestTr(id, trDetails));
  },
  getNetScan: () => {
    dispatch(getNetScan());
  },
  updateNetScan: netScanDetails => {
    dispatch(updateNetScan(netScanDetails));
  },
  getUpTime: () => {
    dispatch(getUpTime());
  },
  updateSubTestUptime: details => {
    dispatch(updateSubTestUptime(details));
  },
  getMaxThroughPut: () => {
    dispatch(getMaxThroughPut());
  },
  updateMaxThroughPut: maxThroughPutDetails => {
    dispatch(updateMaxThroughPut(maxThroughPutDetails));
  },
  getWireMap: type => {
    dispatch(getWireMap(type));
  },

  getCableList: id => {
    dispatch(getCableList(id));
  },
  updateCableList: details => {
    dispatch(updateCableList(details));
  },
  DeleteCable: id => {
    dispatch(DeleteCable(id));
  },
  getSubtestSettings: subTestType => {
    dispatch(getSubtestSettings(subTestType));
  },
  updateSubTestSettings: subTestSettingsDetails => {
    dispatch(updateSubTestSettings(subTestSettingsDetails));
  },
  updateWireMap: details => {
    dispatch(updateWireMap(details));
  },
  getFiberLengthLoss: () => {
    dispatch(getFiberLengthLoss());
  },
  updateFiberLengthLoss: fiberLengthLossDetails => {
    dispatch(updateFiberLengthLoss(fiberLengthLossDetails));
  },
  getFiberLength: () => {
    dispatch(getFiberLengthLoss("navitek"));
  },
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SubTestSettingPage)
);
